import {AppLoader, Globals} from "./app/classes/Globals";
import {Subject} from "rxjs";
import {Project} from "./app/types/sherpa";

export let global: Globals = {
	activeProject: null,
	projectSubject: null,
	loader: AppLoader.PAGE,
	loginUser: null,
	loginModal: false,
	requestedUrl: '',
	menu: true,
	hideAll: false,
	menuItems: [],
	disableLoader: () => {
		global.loader = AppLoader.NONE;
	},
	enableLoader: () => {
		global.loader = AppLoader.PAGE;
	}
};
